<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title"> New update is Available! </div>
    <div class="sopo-popup-text"> Please update to latest version {{ version }} <span *ngIf="!isStaging">from the store</span></div>
    <div class="sopo-popup-button-container">
        <div *ngIf="!isStaging" class="sopo-popup-green-button ion-activatable clickable" (click)="update()">
            Update
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div *ngIf="!isForced" class="sopo-popup-yellow-button ion-activatable clickable" (click)="close(false)">
            Later
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
</div>